export default {"src":"/_next/static/media/building-2.610ed67c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};